import { UserState, UserActions } from '../actions/auth/auth.types';

import {
  USER_LOADING,
  CREATE_USER_SUCCESS,
  USER_LOGIN_SUCCESS,
  CREATE_USER_FAILURE,
} from '../actions/auth/actions';

export const initialState: UserState = {
  user: null,
  error: null,
  loading: false,
};

const authReducer = (state = initialState, action: UserActions) => {
  switch (action.type) {
    case USER_LOADING:
      return { ...state, loading: true };

    case CREATE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        user: {
          ...action.payload,
        },
      };

    case USER_LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        user: {
          ...action.payload,
        },
      };

    case CREATE_USER_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    default:
      return state;
  }
};

export default authReducer;
